import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
  query ($limit: Int, $filters:[Filter]) {
      ViLabels (limit: $limit, filters: $filters) {
        ...viLabelDetail
      }
    }
    ${fragments.viLabelDetail}
    ${fragments.kgraphDetail}
    ${fragments.viLabelProps}
  `
